import Vue from 'vue'
import {
    Button,
    Row,
    Col,
    Dropdown,
    Menu,
    Icon,
    Tooltip,
    Spin,
    Carousel,
    message,
    Modal
} from 'ant-design-vue';


Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Icon)
Vue.use(Tooltip)
Vue.use(Spin)
Vue.use(Carousel)
Vue.use(Modal)
Vue.prototype.$message = message;